
import { ADDCASHPAYMENT, GETCATEGORYWISECOUNTERSALE, GETCATEGORYWISECOUNTERSALEXLSX, GETCOUNTERSALESCUSTOMERS, GETPAYMENTRECEIPT, GETPAYMENTRECEIPTS, GETPAYMENTXLSX, GETUNPAIDBILLS } from "../../utils/api"
import axios from "../../utils/axios";
export const getCategorySalesCustomers=async(param)=>{
    const res=await axios.post(GETCATEGORYWISECOUNTERSALE,param);
    return res;
}

export const getCategoryWiseCounterSalesReportXlsx=async(param,options)=>{
    const res=await axios.post(GETCATEGORYWISECOUNTERSALEXLSX,param,options);
    return res;
}